import { Link } from "@models/ISchema";

export const getLinkTypeGroup = (link: Link) => {
  let result = "";

  link?.groups?.forEach(value => {
    const groupsSection = result && result.split(",").find(item => item === value.type);
    if (result === "") {
      result = value.type;
    } else {
      if (!groupsSection) result = `${result}, ${value.type}`;
    }
  });

  return result;
};
